import { withPageAuthRequired } from "@common/middleware";
import { EulaFormattedText } from "@earned/core";
import { SIGNUP_TERMS_HEADER } from "@earned/wizard";
import { useGetClientEULA } from "@modules/eula/queries";

const ForYouPage = () => {
  const { data: eulaData } = useGetClientEULA();

  return (
    <div className="flex flex-col">
      <div className="overflow-y-scroll px-10 pt-5 text-justify">
        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          {SIGNUP_TERMS_HEADER}
        </h5>
        {eulaData?.latest_eula_text && (
          <EulaFormattedText content={eulaData.latest_eula_text} />
        )}

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Basic Disclosures
        </h5>
        <p className="mb-3 mt-5">
          The recommendations provided are not guarantees of investment
          performance or the full attainment of your goal. The results of this
          plan are based on assumptions for, among other things, historical
          investment performance, client savings rates, average inflation rates
          and estimated tax rates. In addition, investment expenses have not
          been considered in any of the calculations. Therefore, all projections
          are hypothetical in nature and meant to be used for illustrative
          purposes only. This report is not an official document and cannot be
          used as verification of your financial situation for tax preparation,
          loan applications, or any other purpose. The information generated
          regarding the likelihood of various investment outcomes are
          hypothetical in nature, do not reflect actual investment results, and
          are not guarantees of future results. The returns are not reflective
          of any specific product, and do not include any fees or expenses that
          may be incurred by investing in specific products. The actual returns
          of a specific product may be more or less than the returns used in
          this report. It is not possible to directly invest in an index.
          Financial forecasts, rates of return, risk, inflation, and other
          assumptions may be used as the basis for illustrations. They should
          not be considered a guarantee of future performance or a guarantee of
          achieving overall financial objectives. Past performance is not a
          guarantee or a predictor of future results of either the indices or
          any particular investment. Results may vary with each use and over
          time.
        </p>

        <p className="mb-3 mt-5">
          The information generated regarding the likelihood of various
          investment outcomes are hypothetical in nature, do not reflect actual
          investment results, and are not guarantees of future results.
        </p>

        <p className="mb-3 mt-5">
          The returns are not reflective of any specific product, and do not
          include any fees or expenses that may be incurred by investing in
          specific products. The actual returns of a specific product may be
          more or less than the returns used in this report. It is not possible
          to directly invest in an index. Financial forecasts, rates of return,
          risk, inflation, and other assumptions may be used as the basis for
          illustrations. They should not be considered a guarantee of future
          performance or a guarantee of achieving overall financial objectives.
          Past performance is not a guarantee or a predictor of future results
          of either the indices or any particular investment.
        </p>

        <p className="mb-3 mt-5">
          Results may vary with each use and over time.
        </p>

        <p className="mb-3 mt-5">
          This Report provides a snapshot of your current financial position and
          can help you to focus on your financial resources and goals, and to
          create a plan of action. Because the results are calculated over many
          years, small changes can create large differences in future results.
          You should use this Report to help you focus on the factors that are
          most important to you.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Investment Disclosures
        </h5>

        <p className="mb-3 mt-5">
          The projected investment returns are hypothetical in nature and do not
          reflect actual investment returns in the future.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Data Integrity
        </h5>

        <p className="mb-3 mt-5">
          The results of this plan are based, in large part, by the data that
          you have either entered into the Earned Wealth™ application or
          provided to your financial professional. Any underestimations or
          overestimations of data entered by you could drastically change the
          recommendations made by your financial professional. It is important
          to update your financial information frequently.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Tax & Legal Advice
        </h5>

        <p className="mb-3 mt-5">
          The creation and results of this plan do not constitute legal or tax
          advice. You should consult with an attorney or an accountant for
          advice in those areas.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Circular 230
        </h5>

        <p className="mb-3 mt-5">
          IRS Circular 230 Notice: Any tax advice provided herein is not
          intended or written to be used, and cannot be used, for the purpose of
          avoiding penalties that may be imposed on any taxpayer.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Limits of financial modeling
        </h5>

        <p className="mb-3 mt-5">
          Market volatility may be more extreme than what is represented by the
          simulation. The accuracy of the simulation is reduced in periods of
          market crisis. The simulation does not consider all investments, and
          those not considered might have characteristics similar or superior to
          those analyzed in this report.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Client Future Situation
        </h5>

        <p className="mb-3 mt-5">
          It is possible that your income, cash flow and ability to save may
          change in the future. The projections, in large part, are based on the
          data that you have provided. It is important to update your plan
          frequently to account for any changes in your financial status.
          Therefore, the results of this plan today cannot account for future
          changes in your financial situation.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Information that You Provide
        </h5>

        <p className="mb-3 mt-5">
          Information that you provided about your assets, financial goals, and
          personal situation are key assumptions for the calculations and
          projections in this Report. Please review the Report to verify the
          accuracy of these assumptions. If any of the assumptions are
          incorrect, you should notify your financial advisor. Even small
          changes in assumptions can have a substantial impact on the results
          shown in this Report. The information provided by you should be
          reviewed periodically and updated when either the information or your
          circumstances change.
        </p>

        <p className="mb-3 mt-5">
          All asset and net worth information included in this Report was
          provided by you or your designated agents, and is not a substitute for
          the information contained in the official account statements provided
          to you by custodians. The current asset data and values contained in
          those account statements should be used to update the asset
          information included in this Report, as necessary.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Monte Carlo Simulations
        </h5>

        <p className="mb-3 mt-5">
          Monte Carlo is a process that is used to conduct a statistical
          analysis of a client’s portfolio to determine the probability of the
          client achieving their retirement goal.
        </p>

        <p className="mb-3 mt-5">
          The investment returns for each year are calculated from the return of
          each asset class for that year and the asset allocation of each
          account. Asset class returns are generated from a random distribution.
          Each asset class is linked to an index, or a set of indices, with an
          assumed mean return and standard deviation. Using a correlation matrix
          between all the asset classes, and assuming a normal distribution of
          returns, we generate random returns for each year of the simulation.
        </p>

        <p className="mb-3 mt-5">
          Monte Carlo simulations are used to show how variations in rates of
          return each year can affect your results. A Monte Carlo simulation
          calculates the results by running it many times, each time using a
          different sequence of returns. Some sequences of returns will give you
          better results, and some will give you worse results. These multiple
          trials provide a range of possible results, some successful and some
          unsuccessful. The percentage of trials that were successful is the
          probability that your assumptions could be successful.
        </p>

        <p className="mb-3 mt-5">
          We run 250 trials each time using a different set of asset class
          returns taken from the distribution. At the end of the simulation, we
          calculate the percentage of trials in which the client was able to
          cover all of their expenses until the end of their retirement. This is
          the probability of success.
        </p>

        <p className="mb-3 mt-5">
          IMPORTANT: The projections or other information generated by this
          Monte Carlo simulation regarding the likelihood of various investment
          outcomes are hypothetical in nature, do not reflect actual investment
          results and are not guarantees of future results. There is no
          guarantee that the results generated by this simulation will be
          achieved or sustained, and results may vary with each use. Projections
          are based on assumptions provided by you and your
          advisor/representative, and are not guaranteed. Actual results will
          vary, perhaps to a significant degree. The projected reports are
          hypothetical in nature and for illustrative purposes only.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Investment and Insurance Product Fees{" "}
        </h5>

        <p className="mb-3 mt-5">
          Depending on what investment or insurance product you purchase, you
          may incur front-end charges, annual expenses or performance fees. For
          certain products, you may incur surrender charges, income taxes and
          penalties if the product is sold before a pre-determined period. For
          variable life insurance and annuity products, you will incur mortality
          and expense fees. None of these expenses have been factored into the
          projections. If included, fees and other expenses would materially
          reduce the projections.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Risk Assessment
        </h5>

        <p className="mb-3 mt-5">
          Your risk assessment is based on the category and description of risk
          you chose in the data wizard. It is your responsibility to choose the
          description that you think fits best with your appetite for risk.
          Based on your specific circumstances, you must decide the appropriate
          balance between potential risks and potential returns. The suggested
          allocations herein are based on your chosen risk. They are
          informational only and are only intended to facilitate a discussion
          between you and your advisor. It will be your responsibility to work
          with your advisor and determine what the appropriate asset allocation
          mix may be.
        </p>

        <h5 className="mb-5 mt-3 mt-5 text-heading-5 font-medium">
          Risks in Investing
        </h5>

        <p className="mb-3 mt-5">
          Investing in fixed income securities involves interest rate risk,
          credit risk, and inflation risk. Interest rate risk is the possibility
          that bond prices will decrease because of an interest rate increase.
          When interest rates rise, bond prices and the values of fixed income
          securities fall. When interest rates fall, bond prices and the values
          of fixed income securities rise. Credit risk is the risk that a
          company will not be able to pay its debts, including the interest on
          its bonds. Inflation risk is the possibility that the interest paid on
          an investment in bonds will be lower than the inflation rate,
          decreasing purchasing power.
        </p>

        <p className="mb-3 mt-5">
          Cash alternatives typically include money market securities and U.S.
          treasury bills. Investing in such cash alternatives involves inflation
          risk. In addition, investments in money market securities may involve
          credit risk and a risk of principal loss. Because money market
          securities are neither insured nor guaranteed by the Federal Deposit
          Insurance Corporation or any other government agency, there is no
          guarantee the value of your investment will be maintained at $1.00 per
          share. U.S. Treasury bills are subject to market risk if sold prior to
          maturity. Market risk is the possibility that the value, when sold,
          might be less than the purchase price.
        </p>

        <p className="mb-3 mt-5">
          Investing in stock securities involves volatility risk, market risk,
          business risk, and industry risk. The prices of most stocks fluctuate.
          Volatility risk is the chance that the value of a stock will fall.
          Market risk is chance that the prices of all stocks will fall due to
          conditions in the economic environment. Business risk is the chance
          that a specific company’s stock will fall because of issues affecting
          it. Industry risk is the chance that a set of factors particular to an
          industry group will adversely affect stock prices within the industry.
        </p>

        <p className="mb-3 mt-5">
          International investing involves additional risks including, but not
          limited to, changes in currency exchange rates, differences in
          accounting and taxation policies, and political or economic
          instabilities that can increase or decrease returns.
        </p>
      </div>
    </div>
  );
};

export default withPageAuthRequired(ForYouPage);
